module.exports = __webpack_public_path__ + "static/mask_lo_028-8317d856ab1300ae8b70f03d5fb502b4.jpg";